/**
 * Klient POST'u dodawania produktu do koszyka.
 *
 * Uzywany przez `ProductCard` (kafelek listy) i `CShopCategoryArticle` (przycisk
 * "Dodaj do koszyka" na karcie produktu). Owija fetch w try/catch i normalizuje
 * response do stalej struktury `{ok, message?}` - callerowi wystarczy sprawdzic
 * flage `ok` i pokazac toast.
 *
 * Route handler `/api/w-card/add-product` czyta HttpOnly cookie `imperial_shop_card`
 * jako aktualne card_id, wola backend REST, po sukcesie zapisuje zwrocone
 * `card_id` z powrotem do cookie (tworzenie koszyka przy pierwszym dodaniu).
 *
 * @param input `id_product` (`m_shop_products.id`) + opcjonalny `count` (default 1)
 * @returns `{ok: true}` gdy dodane, `{ok: false, message}` z tresci backendu przy bledzie
 */
export async function addProductToCart(input: {
  id_product: number;
  count?: number;
}): Promise<AddProductToCartResult> {
  let response: Response;
  try {
    response = await fetch("/api/w-card/add-product", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_product: input.id_product,
        count: input.count ?? 1,
      }),
    });
  } catch (e) {
    return {
      ok: false,
      message: e instanceof Error ? e.message : String(e),
    };
  }

  const payload = (await response.json().catch(() => ({}))) as Partial<AddProductResponsePayload>;

  if (!response.ok || payload.ok !== true) {
    return {
      ok: false,
      code: payload.code ?? null,
      message: typeof payload.message === "string" ? payload.message : null,
    };
  }

  return { ok: true };
}

export type AddProductToCartResult =
  | { ok: true }
  | { ok: false; code?: number | string | null; message?: string | null };

type AddProductResponsePayload = {
  ok?: boolean;
  code?: number | string;
  message?: string;
};
